export default (time = 0) => {
  const minutes = parseInt(time / 60.0)
  const seconds = parseInt(time % 60.0)
  const paddedSeconds = prettifyTimeUnit(seconds)
  return `${minutes}:${paddedSeconds}`
}

export const prettifyTimeUnit = (value) => {
  return `0${value}`.slice(-2)
}
